import { render, staticRenderFns } from "./SwitchboardActivityReportCard.vue?vue&type=template&id=5b83f644&scoped=true&"
import script from "./SwitchboardActivityReportCard.vue?vue&type=script&lang=js&"
export * from "./SwitchboardActivityReportCard.vue?vue&type=script&lang=js&"
import style0 from "./SwitchboardActivityReportCard.vue?vue&type=style&index=0&id=5b83f644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83f644",
  null
  
)

export default component.exports